"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Favicon.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c88b87"),
    marko_node0 = marko_createElement("br", null, "1", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  const
  { type, name, description, namespace, nsi, version, favicon } = input,
  src = /\.(png|jpe?g|gif|webp|svg)/.test( favicon ) ?
                        /^https?:\/\//.test( favicon ) ? favicon : `${window.marketplace}/${namespace}/${nsi}~${version}/${favicon}` 
                        : false,
  title = input[ input.asTitle ] || name || description

  if (src) {
    Image_tag({
        alt: name,
        src: src,
        style: ("width:" + (input.width || 60)) + "px",
        icon: "bx bx-cube-alt",
        class: input.class,
        title: title,
        noBackground: true
      }, out, __component, "0");

    out.n(marko_node0, component);
  } else {
    out.be("span", {
        title: description
      }, "2", component);

    Bx_tag({
        type: "extension",
        class: input.class
      }, out, __component, "3");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
